export const headerNames = {
	country: 'x-user-country',
} as const
